import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import { InArticleMobileAd, LeftSidebarAd, RightSidebarAd } from '../common/ads/AdFit';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* 모바일 상단 광고 영역 */}
      <div className="w-full bg-white shadow-sm md:hidden">
        <div className="flex justify-center py-2">
          <InArticleMobileAd />
        </div>
      </div>

      <Navigation />
      
      {/* 메인 콘텐츠와 사이드바 광고 영역 */}
      <div className="flex-grow flex">
        {/* 좌측 사이드바 광고 (PC 전용) */}
        <aside className="hidden lg:block w-[160px]">
          <div className="sticky top-4">
            <LeftSidebarAd />
          </div>
        </aside>

        {/* 메인 콘텐츠 */}
        <main className="flex-1">
          {children}
        </main>

        {/* 우측 사이드바 광고 (PC 전용) */}
        <aside className="hidden lg:block w-[160px]">
          <div className="sticky top-4">
            <RightSidebarAd />
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;